import React from 'react';
import { motion } from 'framer-motion';

function ErrorMessage(props) {
    const {text, className } = props;
    return (
        <motion.p
            className={`font-normal text-[#B51803] text-sm errors mt-1 ${className || ''}`}>{text === undefined ? 'This field is mandatory' : text}
        </motion.p>
    );
}

export default ErrorMessage;